'use strict';
angular.module('cvsApp').factory('getLiveChatTokenModel', [function (CM) {

    var getLiveChatTokenModel = function () {


        var self = this;
        this.apiResponse = {};

        this.getResponse = function () {
            return self;
        }

        this.setResponse = function (data) {
            this.apiResponse = data;
        }

        this.getError = function () {
            if (this.apiResponse && this.apiResponse.data.statusCode != "0000") {
                this.apiResponse.showError = this.apiResponse
                return this.apiResponse.showError;
            }
            return "";
        } 

        this.getLPToken = function () {
            if (!this.apiResponse.showError && this.apiResponse.data.hasOwnProperty('token')) {
                return this.apiResponse.data;
            }
        }

    }

    return new getLiveChatTokenModel();

}]);